<template>
  <b-modal
    title-class="modal__title"
    v-if="renouvellement"
    id="modal-renouvellement-delete"
    size="md"
    title="Supprimer le renouvellement"
    @ok="onDelete"
    @cancel="resetRenouvellementForm"
  >
    <p class="mt-3 modal-delete__text">
      Souhaitez-vous supprimer le renouvellement ?
    </p>
    <template #footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button variant="danger" title="Valider la suppression" @click="ok()">
        Supprimer
      </b-button>
      <b-button
        variant="default"
        title="Annuler la suppression"
        @click="cancel()"
      >
        Annuler
      </b-button>
    </template>
  </b-modal>
</template>
<script setup>
import { BModal, BButton } from "bootstrap-vue-next";
import {useReactiveStoreGetters} from "@/composables/useStore";
import {renouvellementService} from "@/service/renouvellement.service";
import {commonService} from "@/service/common.service";
import store from "@/store";

// Props
const {updateParc} = defineProps({ updateParc: Function });

// MapGetters from store
const {
  parc,
  isRenouvellementsNotables,
  isRenouvellementsSubstantiels,
  isRenouvellements,
  renouvellement
} = useReactiveStoreGetters([
  'parc',
  'isRenouvellementsNotables',
  'isRenouvellementsSubstantiels',
  'isRenouvellements',
  'renouvellement'
]);

// Suppresion d'un renouvellement
const onDelete = async () => {
  if (renouvellement.value) {
    // Suppression des renouvellements en base
    await deleteRenouvellementById();
  }
};

const deleteRenouvellementById = async () => {
  const response = await renouvellementService.deleteRenouvellementById(renouvellement.value.id);
  commonService.handleAnyResponse(response);

  // Mise à jour des renouvellements stockés par Vue
  store.dispatch("removeRenouvellement", renouvellement.value);

  // Mise à jour des booléens dans l'objet Parc
  if (!isRenouvellementsNotables.value) {
    parc.value.renouvellementNotable = false;
  }
  if (!isRenouvellementsSubstantiels.value) {
    parc.value.renouvellementSubstantiel = false;
  }
  if (!isRenouvellements.value) {
    parc.value.renouvellement = false;
  }
  updateParc(parc.value);

  resetRenouvellementForm();
}

const resetRenouvellementForm = () => {
  store.dispatch('saveRenouvellement', { parc: renouvellement.value.parc, type: 'S', dateRenouvellement: new Date() });
}

</script>
